import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getTeamMembers = () =>
  axiosInstance.get(`${LANDING_API_URL}/team-members`, {
    headers: authHeaders(),
  });

export const createTeamMemberRequest = (formData) =>
  axiosInstance.post(`${LANDING_API_URL}/team-members`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });

export const updateTeamMemberRequest = (teamMemberId, formData) =>
  axiosInstance.post(
    `${LANDING_API_URL}/team-members/${teamMemberId}`,
    formData,
    {
      headers: authHeaders({ "Content-Type": "multipart/form-data" }),
    },
  );

export const removeTeamMember = (teamMemberId) =>
  axiosInstance.delete(`${LANDING_API_URL}/team-members/${teamMemberId}`, {
    headers: authHeaders(),
  });
